import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ChangeForm from './ChangeForm.jsx'
//import _ from 'lodash'

class ChangeComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.employee.employee) {
      return <div><ChangeForm employee={this.props.employee}></ChangeForm></div>
    }
    return <div></div>
  }
}

ChangeComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  employee: PropTypes.object.isRequired,
}

export default ChangeComponent
